import { useMutation, useQuery } from "@tanstack/react-query";
import {
  addLocation,
  getElevationData,
  getLocationList,
  getLocations,
  updateLocation,
} from "~/services/location.service";

export function useLocationQuery() {
  return useQuery({
    queryFn: () => getLocations(),
    queryKey: ["location_data"],
  });
}
export function useLocationMutation() {
  return useMutation((payloads) => addLocation(payloads));
}
export function useCreateLocation() {
  return useMutation((payloads) => getLocationList(payloads));
}
export function useUpdateLocation() {
  return useMutation((payloads) => updateLocation(payloads));
}

export function getGeoLocations() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation((payloads) => getElevationData(payloads));
}
// export function useLocationDetails() {
//   return useMutation((payloads) => getLocationDetails(payloads));
// }
